var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { attrs: { href: _vm.href, target: "_blank" } },
    [
      _c("span", { staticClass: "sr-only" }, [_vm._v("(opens in a new tab) ")]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }